export default {
  asinStatistics: {
    url: '/productReview/asinStatistics',
    method: 'post',
    desc: '评价统计-review-asin-列表数据'
  },
  getStatistics: {
    url: '/productReview/getStatistics',
    method: 'post',
    desc: '评价统计-review-店铺-评论总计'
  },
  shopStatistics: {
    url: '/productReview/shopStatistics',
    method: 'post',
    desc: '评价统计-review-店铺-列表数据'
  },
  batchDeleteGoodsMonitor: {
    url: '/review/monitor/batchDeleteGoodsMonitor',
    method: 'post',
    desc: '评价统计-review-批量删除'
  },
  getInitGoodsMonitorList: {
    url: '/review/monitor/getInitGoodsMonitorList',
    method: 'post',
    desc: '评价统计-review-一键添加'
  },
  getShopFeedbackStatistics: {
    url: '/feedback/report/getShopFeedbackStatistics',
    method: 'post',
    desc: '评价统计-feedback-列表数据'
  }
}
